<template>
    <div class="index">
        <div class="index-con">
            <div class="big-title">
                <span> IDS 2024 NEWS</span>
            </div>
            <div class="new-list" style="height: auto;margin-top: 6px;" @click="toCall(9)">
                <p style="white-space: wrap">
                    <i class="el-icon-arrow-right"></i>
                    ANNOUNCEMENT | Inaugural Meeting of International Research Association for Drying Science &
                    Technology
                    (Macao)
                    <span class="new-tip-new" style="margin-left: 0">NEW</span>
                </p>
                <span class="icon-span">
                    <i class="el-icon-right"></i>
                </span>
            </div>
            <div class="new-list" @click="toCall(8)">
                <p style="white-space: wrap">
                    <i class="el-icon-arrow-right"></i>
                    {{ $t("newsDetailText33") }}
                    <span class="new-tip-new" style="margin-left: 0">NEW</span>
                </p>
                <span class="icon-span">
                    <i class="el-icon-right"></i>
                </span>
            </div>
            <div class="new-list" @click="toCall(7)">
                <p style="white-space: wrap">
                    <i class="el-icon-arrow-right"></i>
                    {{ $t("newsDetailText21") }}
                    <span class="new-tip-new" style="margin-left: 0">NEW</span>
                </p>
                <span class="icon-span">
                    <i class="el-icon-right"></i>
                </span>
            </div>
            <div class="new-list" @click="toCall(6)">
                <p style="white-space: wrap">
                    <i class="el-icon-arrow-right"></i>
                    {{ $t("newsDetailText10") }}
                    <span class="new-tip-new" style="margin-left: 0">NEW</span>
                </p>
                <span class="icon-span">
                    <i class="el-icon-right"></i>
                </span>
            </div>
            <div class="new-list" @click="toCall(5)">
                <p style="white-space: wrap">
                    <i class="el-icon-arrow-right"></i>
                    {{ $t("newsDetailText8") }}
                </p>
                <span class="icon-span">
                    <i class="el-icon-right"></i>
                </span>
            </div>
            <div class="new-list" @click="toCall(4)">
                <p>
                    <i class="el-icon-arrow-right"></i>
                    {{ $t("newsDetailText5") }}
                </p>
                <span class="icon-span">
                    <i class="el-icon-right"></i>
                </span>
            </div>
            <div class="new-list" @click="toCall(3)">
                <p style="white-space: wrap">
                    <i class="el-icon-arrow-right"></i>
                    {{ $t("newsDetailText1") }}
                </p>
                <span class="icon-span">
                    <i class="el-icon-right"></i>
                </span>
            </div>
            <div class="new-list" @click="toCall(1)">
                <p>
                    <i class="el-icon-arrow-right"></i>
                    Special issues of "Drying Technology" and "Processes" will publish
                    the full papers from IDS2024
                </p>
                <span class="icon-span">
                    <i class="el-icon-right"></i>
                </span>
            </div>
            <div class="new-list" @click="toCall(2)">
                <p>
                    <i class="el-icon-arrow-right"></i>
                    {{ $t("indexText3") }}
                </p>
                <span class="icon-span">
                    <i class="el-icon-right"></i>
                </span>
            </div>

        </div>
    </div>
</template>
<script>
export default {
    methods: {
        toCall(index) {
            if (index == 1) {
                this.$router.push("/newsDetail1");
            } else if (index == 2) {
                this.$router.push("/newsDetail");
            } else if (index == 3) {
                this.$router.push("/newsDetail3");
            } else if (index == 4) {
                this.$router.push("/newsDetail4");
            } else if (index == 5) {
                this.$router.push("/newsDetail5");
            } else if (index == 6) {
                this.$router.push("/newsDetail6");
            } else if (index == 7) {
                this.$router.push("/newsDetail7");
            } else if (index == 8) {
                this.$router.push("/program");
            } else if (index == 9) {
                this.$router.push("/newsDetail8");
            }
        },
    },
}
</script>
<style scoped>
.index-con {
    width: 1000px;
    margin: 0 auto;
    padding: 40px 0;
}

.new-list {
    display: flex;
    min-height: 30px;
    font-size: 15px;
    align-items: center;
    cursor: pointer;
    justify-content: space-between;
}

.new-list p {
    padding-left: 17px;
    line-height: 1.3;
    position: relative;
}

.new-list p i {
    position: absolute;
    left: 0;
    top: 4px;
}

.new-list .icon-span {
    flex-shrink: 0;
}

.new-list b,
.new-list span {
    font-size: 14px;
}

.new-tip-new {
    width: 40px;
    text-align: center;
    display: inline-block;
    height: 20px;
    line-height: 20px;
    font-size: 12px;
    background: #8198f4;
    color: #fff;
    border-radius: 4px;
    transform: scale(0.75);
}
</style>


// WEBPACK FOOTER //
// src/components/newList.vue